
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/airport-security-wait-times",
      function () {
        return require("private-next-pages/airport-security-wait-times/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/airport-security-wait-times"])
      });
    }
  